import React, { useState, useEffect } from 'react';
import { Button } from '../../components/Button';
import { Switch } from '../../components/SettingRow';
import {mnpTransferDateService, TransferDateOptions} from "../../utils/mnpTransferDateService";
import moment from 'moment'
import 'moment/locale/fi';
// @ts-ignore
import { fadeIn } from 'react-animations';
import { TextModal } from '../../components/Modal';
import styled, { keyframes } from 'styled-components';
import {
	isValidPhoneNumber,
	isNotEmptyLengthUnder50,
	isNotEmptyEmailWithLengthUnder80, isValidBusinessId, isValidAdultSsn
} from '../../utils/validator';
import { useValidation } from '../../utils/useValidation';
import {formatMsisdn, getAccountId} from '../../utils/helpers';
import {Checkbox} from "../../components/Checkbox";
import {useApiQuery} from "../../utils/apiHooks";
import {ApiRequest} from "../../utils/api";

interface Props {
	freeNumbers: any;
	customer: any;
	handlerFromParent: (contact: any) => void;
}

const fadeAnimation = keyframes`${fadeIn}`;

const Container = styled.div`
	margin: auto;
	max-width: 30rem;
	text-align: left;
	padding-bottom: 2.5rem;
`;

const FadeContainer = styled.div`
	animation: 0.5s ${fadeAnimation};
	margin: 1rem auto 0;
	text-align: left;
`;

const NewNumberContainer = styled.div`
	margin-top: 1rem;
`;

const Input = styled.input`
	//border: 1px solid #eaeaea;
	&.error {
		color: red;
	}
	&.focus {
		border: 2px solid black;
	}
`;

const ErrorMessage = styled.div`
	font-size: 1rem;
	color: red;
`;

const Select = styled.select`
	width: 10rem;
	background-color: #f6f6f6;
	margin-bottom: 1.8rem;
`;

const PreviousOwnerType = styled.select`
	width: 100%;
	background-color: #f6f6f6;
	margin-bottom: 1.8rem;
`;

const FasterPortingAgreement = styled.div`
	background: #fafafa;
	box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
	//max-width: 500px;
	padding: 0.75rem 1rem;
	margin: 1.5rem 0 2rem;
`;

const GreyTextContainer = styled.div`
	p {
		float: left;
	}
`;
const GreyText = styled.div`
	color: #969696;
	display: inline-block;
`;

const HetuFade = styled.div`
	animation: 0.5s ${fadeAnimation};
`;

const UseEarliestRadioButtons = styled.fieldset`
	border: 1px solid #d4d4d4;
	border-radius: 4px;
	padding: .5rem 1rem .35rem;
`;

const MnpDateSelector = styled.div`
	label {
		color: #969696;
		font-size: 1rem;
	}
	
	h4 {
		text-align: center;
	}
`;

const SelectTransferDate = styled.div`
	padding: 1rem 0;
`;

const DatePickerWrapper = styled.div`
  margin-top: 3px;
  padding: 0 1.25rem .75rem;

  label {
    display: block;
    text-align: center;
  }
`;


export const SubscriptionActivationForm: React.FC<Props> = (props: Props) => {
	const { data: accountOwner } = useApiQuery(ApiRequest.getAccountOwner(getAccountId()));
	const { data: transferDateInfo } = useApiQuery(ApiRequest.getTransferDates());
	const selectedPreviousOwnerTypeList = ['Yritys omistaa itse liittymän', 'Liittymän omistaja on yksityinen henkilö', 'Liittymän omistaja on muu yritys'];
	const [simName, setSimName] = useState('');
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [mnpPhoneNumber, setMnpPhoneNumber] = useState('');
	const [costCenterName, setCostCenterName] = useState('');
	const [costCenterAddress, setCostCenterAddress] = useState('');
	const [isMnp, setMnp] = useState(false);
	const [selectedPhoneNumber, setSelectedPhoneNumber] = useState('');
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [modalContent, setModalContent] = useState('');
	const [selectedPreviousOwnerType, setSelectedPreviousOwnerType] = useState(selectedPreviousOwnerTypeList[0]);
	const [isFasterPorting, setIsFasterPorting] = useState(false);
	const [mnpPersonFirstName, setMnpPersonFirstName] = useState('');
	const [mnpPersonLastName, setMnpPersonLastName] = useState('');
	const [mnpPersonSsn, setMnpPersonSsn] = useState('');
	const [mnpPersonEmail, setMnpPersonEmail] = useState('');
	const [mnpCompanyName, setMnpCompanyName] = useState('');
	const [mnpBusinessId, setMnpBusinessId] = useState('');
	const [mnpProcuraFirstName, setMnpProcuraFirstName] = useState('');
	const [mnpProcuraLastName, setMnpProcuraLastName] = useState('');
	const [mnpProcuraEmail, setMnpProcuraEmail] = useState('');
	const [hasPreviousFixedTermContract, setHasPreviousFixedTermContract] = useState<boolean | null>(null);
	const [selectedTransferDate, setSelectedTransferDate] = useState<string | null>(null);
	const [useEarliestDate, setUseEarliestDate] = useState(true);
	const [isValidInput, setIsValidInput] = useState(false);
	const [mnpTransferDateOptions, setMnpTransferDateOptions] = useState<TransferDateOptions | null>(null);

	const simNameValidation = useValidation(simName, isNotEmptyLengthUnder50);
	const firstNameValidation = useValidation(firstName, isNotEmptyLengthUnder50);
	const lastNameValidation = useValidation(lastName, isNotEmptyLengthUnder50);
	const mnpPhoneNumberValidation = useValidation(mnpPhoneNumber, isValidPhoneNumber);
	const mnpPersonFirstNameValidation = useValidation(mnpPersonFirstName, isNotEmptyLengthUnder50);
	const mnpPersonLastNameValidation = useValidation(mnpPersonLastName, isNotEmptyLengthUnder50);
	const mnpPersonSsnValidation = useValidation(mnpPersonSsn, isValidAdultSsn);
	const mnpPersonEmailAddressValidation = useValidation(mnpPersonEmail, isNotEmptyEmailWithLengthUnder80);
	const mnpCompanyNameValidation = useValidation(mnpCompanyName, isNotEmptyLengthUnder50);
	const mnpBusinessIdValidation = useValidation(mnpBusinessId, isValidBusinessId);
	const mnpProcuraFirstNameValidation = useValidation(mnpProcuraFirstName, isNotEmptyLengthUnder50);
	const mnpProcuraLastNameValidation = useValidation(mnpProcuraLastName, isNotEmptyLengthUnder50);
	const mnpProcuraEmailAddressValidation = useValidation(mnpProcuraEmail, isNotEmptyEmailWithLengthUnder80);
	enum PreviousContractType {
		Fixed = 'fixed',
		Open = 'open',
	}

	const mnpBusinessIdDiffersFromOrdererValidation = () => {
		return accountOwner !== undefined && mnpBusinessId !== accountOwner.businessOwner?.businessId;
	}
	const { freeNumbers } = props;

	useEffect(() => {
		const arr = freeNumbers.toJS() as any;
		setSelectedPhoneNumber(arr[0].msisdn);
	}, [freeNumbers]);

	useEffect(() => {
		setIsValidInput(checkValidity(isMnp));
	}, [isMnp, simName, firstName, lastName, mnpPhoneNumber, mnpPersonFirstName, mnpPersonLastName, mnpPersonSsn, // eslint-disable-line
		mnpPersonEmail, mnpCompanyName, mnpBusinessId, mnpProcuraFirstName, mnpProcuraLastName, mnpProcuraEmail,
		isFasterPorting, selectedPreviousOwnerType, accountOwner, hasPreviousFixedTermContract]);

	useEffect(() => {
		if (transferDateInfo) {
			setMnpTransferDateOptions(mnpTransferDateService.getTransferDates(transferDateInfo));
		}
	}, [transferDateInfo]);

	const checkValidity = (isMnp: boolean) => {
		const validNames = firstNameValidation.isValid && lastNameValidation.isValid && simNameValidation.isValid;
		if (isMnp) {
			if (selectedPreviousOwnerType === selectedPreviousOwnerTypeList[0]) {
				return (
					validNames &&
					mnpPhoneNumberValidation.isValid &&
					isFasterPorting &&
					hasPreviousFixedTermContract !== null
				);
			} else if (selectedPreviousOwnerType === selectedPreviousOwnerTypeList[1]) {
				return (
					validNames &&
					mnpPhoneNumberValidation.isValid &&
					mnpPersonFirstNameValidation.isValid &&
					mnpPersonLastNameValidation.isValid &&
					mnpPersonSsnValidation.isValid &&
					mnpPersonEmailAddressValidation.isValid &&
					isFasterPorting &&
					hasPreviousFixedTermContract !== null
				);
			}
			return (
				validNames &&
				mnpPhoneNumberValidation.isValid &&
				mnpCompanyNameValidation.isValid &&
				mnpBusinessIdValidation.isValid &&
				mnpBusinessIdDiffersFromOrdererValidation() &&
				mnpProcuraFirstNameValidation.isValid &&
				mnpProcuraLastNameValidation.isValid &&
				mnpProcuraEmailAddressValidation.isValid &&
				isFasterPorting &&
				hasPreviousFixedTermContract !== null
			);
		}
		return validNames;
	};

	const handleToggleUseEarliestDate = (value: string) => {
		if (value !== 'earliest') {
			setUseEarliestDate(false);
		} else {
			setUseEarliestDate(true);
			setSelectedTransferDate(null);
		}
	};

	const handleSubmit = () => {
		if (checkValidity(isMnp)) {
			const contact: any = {
				simName,
				firstName,
				lastName,
				number: selectedPhoneNumber,
				costCenterName,
				costCenterAddress,
				isMnp: true
			};

			if (!isMnp) {
				contact.isMnp = false;
				contact.adInfo = '';
				props.handlerFromParent(contact);
			} else if (selectedPreviousOwnerType === selectedPreviousOwnerTypeList[0]) {
				contact.number = mnpPhoneNumber;
				contact.ordererOwnsNumber = true;
				contact.hasPreviousFixedTermContract = hasPreviousFixedTermContract;
				contact.selectedTransferDate = selectedTransferDate;
				props.handlerFromParent(contact);
			} else if (selectedPreviousOwnerType === selectedPreviousOwnerTypeList[1]) {
				contact.number = mnpPhoneNumber;
				contact.ordererOwnsNumber = false;
				contact.hasPreviousFixedTermContract = hasPreviousFixedTermContract;
				contact.selectedTransferDate = selectedTransferDate;
				contact.personOwner = {
					ssn: mnpPersonSsn,
					firstName: mnpPersonFirstName,
					lastName: mnpPersonLastName,
					emailAddress: mnpPersonEmail
				}
				props.handlerFromParent(contact);
			} else if (selectedPreviousOwnerType === selectedPreviousOwnerTypeList[2]) {
				contact.number = mnpPhoneNumber;
				contact.ordererOwnsNumber = false;
				contact.hasPreviousFixedTermContract = hasPreviousFixedTermContract;
				contact.selectedTransferDate = selectedTransferDate;
				contact.businessOwner = {
					companyName: mnpCompanyName,
					businessId: mnpBusinessId,
					procuraFirstName: mnpProcuraFirstName,
					procuraLastName: mnpProcuraLastName,
					procuraEmailAddress: mnpProcuraEmail
				}
				props.handlerFromParent(contact);
			}
		} else {
			setModalContent('Tarkista kentät');
			setModalIsOpen(true);
		}
	};

	return (
		<Container>
			<TextModal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)} content={modalContent} />
			<p>Simmin nimi</p>
			<Input type="text" placeholder="Simmin nimi" onChange={(e) => setSimName(e.target.value)} />
			<ErrorMessage>{simNameValidation.showError && 'Tarkista simmin nimi'}</ErrorMessage>

			<p>Käyttäjän etunimi</p>
			<Input type="text" placeholder="Etunimi" onChange={(e) => setFirstName(e.target.value)} />
			<ErrorMessage>{firstNameValidation.showError && 'Tarkista etunimi'}</ErrorMessage>

			<p>Käyttäjän sukunimi</p>
			<Input type="text" placeholder="Sukunimi" onChange={(e) => setLastName(e.target.value)} />
			<ErrorMessage>{lastNameValidation.showError && 'Tarkista sukunimi'}</ErrorMessage>

			<GreyTextContainer>
				<p>Kustannuspaikan nimi</p> <GreyText>(vapaaehtoinen tieto)</GreyText>
			</GreyTextContainer>
			<Input type="text" placeholder="Kustannuspaikan nimi" onChange={(e) => setCostCenterName(e.target.value)} />

			<GreyTextContainer>
				<p>Kustannuspaikan osoite</p> <GreyText>(vapaaehtoinen tieto)</GreyText>
			</GreyTextContainer>
			<Input type="text" placeholder="Kustannuspaikan osoite" onChange={(e) => setCostCenterAddress(e.target.value)} />
			<Switch title="Säilytä käyttäjän nykyinen puhelinnumero" onChange={() => setMnp(!isMnp)} checked={isMnp} />
			{isMnp && (
				<FadeContainer>
					<p>Numero</p>
					<Input type="text" placeholder="Numero" onChange={(e) => setMnpPhoneNumber(e.target.value)} />
					<ErrorMessage>{mnpPhoneNumberValidation.showError && 'Tarkista numero.'}</ErrorMessage>
					<PreviousOwnerType onChange={(e: any) => setSelectedPreviousOwnerType(e.target.value)} value={selectedPreviousOwnerType}>
						<option key={Math.random().toString(36).substring(7)} value={selectedPreviousOwnerTypeList[0]}>
							{selectedPreviousOwnerTypeList[0]}
						</option>
						<option key={Math.random().toString(36).substring(7)} value={selectedPreviousOwnerTypeList[1]}>
							{selectedPreviousOwnerTypeList[1]}
						</option>
						<option key={Math.random().toString(36).substring(7)} value={selectedPreviousOwnerTypeList[2]}>
							{selectedPreviousOwnerTypeList[2]}
						</option>
					</PreviousOwnerType>
					{selectedPreviousOwnerType === selectedPreviousOwnerTypeList[0] && (
						<div>
							{accountOwner !== undefined && (
								<div>
									<p>Yrityksen nimi</p>
									<Input type="text" placeholder={accountOwner.businessOwner?.companyName} readOnly/>
									<p>Yrityksen y-tunnus</p>
									<Input type="text" placeholder={accountOwner.businessOwner?.businessId} readOnly/>
									<p>Tarkista, että ylläolevat omistajatiedot on oikein.</p>
								</div>
							)}
						</div>
					)}
					{selectedPreviousOwnerType === selectedPreviousOwnerTypeList[1] && (
						<HetuFade>
							<p>Etunimi</p>
							<Input type="text" placeholder="Etunimi" onChange={(e) => setMnpPersonFirstName(e.target.value)} />
							<ErrorMessage>{mnpPersonFirstNameValidation.showError && 'Tarkista etunimi.'}</ErrorMessage>
							<p>Sukunimi</p>
							<Input type="text" placeholder="Sukunimi" onChange={(e) => setMnpPersonLastName(e.target.value)} />
							<ErrorMessage>{mnpPersonLastNameValidation.showError && 'Tarkista sukunimi.'}</ErrorMessage>
							<p>Henkilötunnus</p>
							<Input type="text" placeholder="Henkilötunnus" onChange={(e) => setMnpPersonSsn(e.target.value)} />
							<ErrorMessage>{mnpPersonSsnValidation.showError && 'Henkilötunnus on virheellinen tai kuuluu alaikäiselle henkilölle.'}</ErrorMessage>
							<p>Sähköpostiosoite</p>
							<Input type="text" placeholder="Sähköpostiosoite" onChange={(e) => setMnpPersonEmail(e.target.value)} />
							<ErrorMessage>{mnpPersonEmailAddressValidation.showError && 'Tarkista sähköpostiosoite.'}</ErrorMessage>
							<div>Jos ette omista tätä liitymää, teillä täytyy olla valtuutus siirtoa varten. Valtuutus voidaan antaa tilauksen jälkeen</div>
						</HetuFade>
					)}
					{selectedPreviousOwnerType === selectedPreviousOwnerTypeList[2] && (
						<HetuFade>
							<p>Yrityksen nimi</p>
							<Input type="text" placeholder="Yrityksen nimi" onChange={(e) => setMnpCompanyName(e.target.value)} />
							<ErrorMessage>{mnpCompanyNameValidation.showError && 'Tarkista nimi.'}</ErrorMessage>
							<p>Yrityksen y-tunnus</p>
							<Input type="text" placeholder="y-tunnus" onChange={(e) => setMnpBusinessId(e.target.value)} />
							<ErrorMessage>{mnpBusinessIdValidation.showError && 'Tarkista y-tunnus.'}</ErrorMessage>
							<ErrorMessage>{accountOwner !== undefined && !mnpBusinessIdDiffersFromOrdererValidation() &&
								'Tarkista y-tunnus. Jos yritys omistaa numeron, valitse se ylävalikosta'}</ErrorMessage>
							<p>Yrityksen allekirjoittajan etunimi</p>
							<Input type="text" placeholder="etunimi" onChange={(e) => setMnpProcuraFirstName(e.target.value)} />
							<ErrorMessage>{mnpProcuraFirstNameValidation.showError && 'Tarkista etunimi.'}</ErrorMessage>
							<p>Yrityksen allekirjoittajan sukunimi</p>
							<Input type="text" placeholder="sukunimi" onChange={(e) => setMnpProcuraLastName(e.target.value)} />
							<ErrorMessage>{mnpProcuraLastNameValidation.showError && 'Tarkista sukunimi.'}</ErrorMessage>
							<p>Yrityksen allekirjoittajan sähköpostiosoite</p>
							<Input type="text" placeholder="Sähköpostiosoite" onChange={(e) => setMnpProcuraEmail(e.target.value)} />
							<ErrorMessage>{mnpProcuraEmailAddressValidation.showError && 'Tarkista sähköpostiosoite.'}</ErrorMessage>
							<div>Jos ette omista tätä liitymää, teillä täytyy olla valtuutus siirtoa varten. Valtuutus voidaan antaa tilauksen jälkeen</div>
						</HetuFade>
					)}
					<MnpDateSelector>
						<h4>Numeron siirtäminen Moille</h4>
						<label htmlFor="previous-contract-type">Nykyinen sopimus on</label>
						<select
							name="previous-contract-type"
							id="previous-contract-type"
							value={hasPreviousFixedTermContract !== null ? (hasPreviousFixedTermContract ? PreviousContractType.Fixed : PreviousContractType.Open) : ""}
							onChange={(e) => {
								setHasPreviousFixedTermContract(e.target.value === PreviousContractType.Fixed);
								if (e.target.value !== PreviousContractType.Fixed) {
									setSelectedTransferDate(null);
									setUseEarliestDate(true);
								}
							}}
						>
							<option value="" disabled>
								Valitse...
							</option>
							<option value={PreviousContractType.Fixed}>
								Määräaikainen sopimus
							</option>
							<option value={PreviousContractType.Open}>
								Toistaiseksi voimassa oleva sopimus
							</option>
						</select>
						{hasPreviousFixedTermContract &&
							<SelectTransferDate>
								<UseEarliestRadioButtons>
									<div onClick={() => handleToggleUseEarliestDate("earliest")}>
										<input
											type="radio"
											id="transfer-soonest"
											name="choose-transfer-date"
											value="earliest"
											checked={useEarliestDate}
											onChange={(e) => handleToggleUseEarliestDate(e.target.value)}
										/>
										<label htmlFor="css">Haluan siirron tapahtuvan heti kun mahdollista.</label><br/>
									</div>
									<div onClick={() => handleToggleUseEarliestDate("later")}>
										<input
											type="radio"
											id="transfer-later"
											name="choose-transfer-date"
											value="later"
											checked={!useEarliestDate}
											onChange={(e) => handleToggleUseEarliestDate(e.target.value)}
										/>
										<label htmlFor="javascript">Ehdota erillistä siirtopäivää.</label>
									</div>
									{mnpTransferDateOptions && !useEarliestDate && (
										<DatePickerWrapper>
											<select
												name="select-tranfer-date"
												id="select-tranfer-date"
												value={selectedTransferDate ? selectedTransferDate : ""}
												onChange={(e) => setSelectedTransferDate(e.target.value)}
											>
												<option value="" disabled>
													Valitse...
												</option>
												{mnpTransferDateOptions.dates.map((date: string, index: number) => {
													return (
														<option value={date} key={index}>
															{ moment(date).format("ddd D.M.Y") }
														</option>
													)
												})}
											</select>
										</DatePickerWrapper>
									)}
								</UseEarliestRadioButtons>
							</SelectTransferDate>
						}
					</MnpDateSelector>
					<FasterPortingAgreement>
						<Checkbox
							messageWidth={'80%'}
							checked={isFasterPorting}
							message={
								<p>
									Numeron saa siirtää, vaikka siinä olisi määräaikainen sopimus nykyisellä operaattorilla. (Pakollinen)
								</p>
							}
							onChange={() => setIsFasterPorting(!isFasterPorting)}
						/>
					</FasterPortingAgreement>
				</FadeContainer>
			)}
			{!isMnp && (
				<NewNumberContainer>
					<p>Valitse puhelinnumero</p>
					<Select onChange={(e: any) => setSelectedPhoneNumber(e.target.value)} value={selectedPhoneNumber}>
						{props.freeNumbers.toJS().map((e: any) => (
							<option key={Math.random().toString(36).substring(7)} value={e.msisdn}>
								{formatMsisdn(e.msisdn)}
							</option>
						))}
					</Select>
				</NewNumberContainer>
			)}
			<Button onClick={handleSubmit} disabled={!isValidInput}>Ota liittymä käyttöön</Button>
		</Container>
	);
};
